import axios from "axios";
import {API_BASE_URL} from "../constant";


/*
    Get All Products
 */

export const allProducts = async () => {
    const response = await axios.get(`${API_BASE_URL}api/products/getAll`);
    const products = response.data;
    return products;
};

/*
    Get Popular Products
 */

export const popularProducts = async () => {
    const response = await axios.get(`${API_BASE_URL}api/products/getAll`);
    const popularProducts = response.data.filter(_product => _product.populaire === true);
    return popularProducts;
};

/*
    Get Categories List
 */

export const categoriesList = async () => {
    const response = await axios.get(`${API_BASE_URL}api/categories/getAll`);
    const categoriesList = response.data;
    return categoriesList;
};


